import { render, staticRenderFns } from "./empleado.register.vue?vue&type=template&id=602f6413&scoped=true&"
import script from "./empleado.register.vue?vue&type=script&lang=js&"
export * from "./empleado.register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f6413",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
